import React, {PropTypes} from 'react';
import Component from 'react-pure-render/component';
import {Col, Row} from 'react-bootstrap/lib/';
import {
  nodeToJs,
  createRadio
} from './utils';

export default class RadiosGroup extends Component {
  static propTypes = {
    updateAction: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    heading: PropTypes.string,
    note: PropTypes.string,
    label: PropTypes.string,
    field: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    otherField: PropTypes.string,
    otherFieldName: PropTypes.string,
    otherFieldPlaceholder: PropTypes.string,
    otherFieldValue: PropTypes.string,
    otherFieldLength: PropTypes.string,
    xs: PropTypes.number.isRequired,
    sm: PropTypes.number,
    inputsXs: PropTypes.number,
    headingXs: PropTypes.number
  }

  isOtherFieldEnabled(value) {
    const {otherField} = this.props;

    if (value !== null && value !== undefined) {
      if ('string' === typeof otherField && otherField.length > 1) {
        return value === otherField;
      }
    }

    return false;
  }

  onRadioChange(event) {
    const {updateAction} = this.props;
    const {name, value} = event.target;
    updateAction({target: {name, value}});
  }

  onInputChange(event) {
    const {updateAction, otherFieldName} = this.props;
    const {target: {value}} = event;

    updateAction({target: {name: otherFieldName, value}});
  }

  render() {
    const {
      children,
      heading,
      note,
      label,
      value,
      field,
      otherField,
      otherFieldPlaceholder,
      otherFieldValue,
      otherFieldLength,
      xs,
      sm,
      headingXs = 12,
      inputsXs = 12
    } = this.props;

    const radioUpdateAction = this.onRadioChange.bind(this);
    let otherFieldEnabled = false;

    if ('string' === typeof otherField && otherField.length > 1) {
      otherFieldEnabled = this.isOtherFieldEnabled(value);
    }

    if (value === null || value === undefined) {
      throw new Error(`Radios:error missing value ${field}`);
    }

    const radios = children
      .map(nodeToJs)
      .map((data) => {
        const {field: itemField, title} = data;
        return {
          action: radioUpdateAction,
          title: title,
          group: field,
          value: value === itemField,
          field: itemField
        };
      })
      .map(createRadio);
    return (

      <Col xs={xs} sm={sm}>
        <Row>
          {heading && <Col xs={headingXs}><h3>{heading}</h3></Col>}
          {label && <Col xs={headingXs}><label>{label}</label></Col>}
          {note && <Col className="group-note" xs={headingXs}>{note}</Col>}
          <Col xs={inputsXs} className="form-inline">
            {radios}
            {
              otherFieldEnabled &&
                <input
                  className="form-control"
                  maxLength={otherFieldLength}
                  onChange={::this.onInputChange}
                  placeholder={otherFieldPlaceholder}
                  type="text"
                  value={otherFieldValue}
                />
            }
          </Col>
        </Row>
      </Col>
    );
  }
}
